import { FormEvent } from 'react';
import { Button, Col, Panel, Row } from 'react-bootstrap'

interface IProps {
    referralSourceList: string[],
    onChange: (index: number, value: string) => void,
    onRemove: (index: number, type: any) => void,
    onAdd: () => void
}

const ReferralSources = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Referral Sources</Panel.Heading>
            <Panel.Body>
                <Row>
                    <Col xs={12} id='referralSource-container'>
                        {props.referralSourceList.map((referralSource, i) => (
                            <Row key={i} className='row-margined xs-only-form-box'>
                                <Col xs={12} sm={4}>
                                    <label className='control-label visible-xs'>
                                        Referral Source
                                    </label>
                                    <input
                                        id={`ReferralSource${i}`}
                                        name={`ReferralSource${i}`}
                                        className='form-control'
                                        type='text'
                                        value={referralSource}
                                        onChange={(e: FormEvent<HTMLInputElement>) => props.onChange(i, e.currentTarget.value)}
                                    />
                                </Col>
                                <Col xs={12} sm={2} className='padtop-xs'>
                                    <Button bsStyle='danger' block onClick={() => props.onRemove(i, 'referral')}>
                                        Remove
                                    </Button>
                                </Col>
                                <Col xs={12} className='visible-xs'>
                                    &nbsp;
                                </Col>
                            </Row>
                        ))}
                    </Col>
                    <Col xs={12}>
                        <div style={{ marginTop: 10 }}>
                            <Button bsStyle='primary' onClick={props.onAdd}>
                                Add Referral Source
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Panel.Body>
        </Panel>
    );
}

export default ReferralSources;